import React from 'react';
import type { SortDescriptor } from '@react-types/shared';
import type { ActivityLogItem } from '@/types';

export const useActivityLogsSorting = (activityLogs: ActivityLogItem[]) => {
  const [sortDescriptor, setSortDescriptor] = React.useState<SortDescriptor | undefined>(undefined);

  const sortedActivityLogs = React.useMemo(() => {
    if (!sortDescriptor?.column) return activityLogs;

    const copy = [...activityLogs];
    const { column, direction } = sortDescriptor;

    const compareStrings = (a: string, b: string) => a.localeCompare(b, undefined, { sensitivity: 'base' });
    const compareNumbers = (a: number, b: number) => a - b;

    copy.sort((a, b) => {
      let cmp = 0;

      switch (column) {
        case 'id':
          cmp = compareNumbers(a.id, b.id);
          break;
        case 'log_name':
          cmp = compareStrings(a.log_name, b.log_name);
          break;
        case 'event':
          cmp = compareStrings(a.event, b.event);
          break;
        case 'created_at':
          cmp = compareStrings(a.created_at, b.created_at);
          break;
        default:
          cmp = 0;
      }

      return direction === 'descending' ? -cmp : cmp;
    });

    return copy;
  }, [activityLogs, sortDescriptor]);

  return { sortDescriptor, setSortDescriptor, sortedActivityLogs };
};

